import LayoutNode, { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { SiteData } from "../Data/SiteData";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import RenderNodeRecursive from "./RenderNodeRecursive";
import { PageData } from "vagaro-website-rendering/src/components/Definitions/UserContext";
import { GetWBComponentByTypename } from "../Data/WBData";
import { GetLinkValidation } from "vagaro-website-rendering/src/components/Definitions/LinkData";


 type NestedLinkNode = {
    node:LayoutNode,
    linkParent:LayoutNode,

}

export function EvaluateNesting(root:LayoutNode){


    let pendingNodes = [...root.children];
    let linkContainers = [];

    do{
        let node = pendingNodes.pop();

        if(node){
            if(node.children.length>0){
                pendingNodes.push(...node.children);
            }
            if(node.typename===wBComponentTypeNames.container&& node.componentAttributes['isLink']==="true"){
                linkContainers.push(node);
            }
        }
    }
    while(pendingNodes.length>0);

    let nested:NestedLinkNode[]= [];

    for(let i = 0;i<linkContainers.length;i++){
        let container = linkContainers[i];
        let links = GetAllNestedLinksInContainer(container);
        nested.push(...links);
    }




    return nested;
}


export function RenderLinkNesting({nested,siteData}:{nested:NestedLinkNode,siteData:SiteData}){

    return <div className="nested-link-preview" style={{width:"350px",height:"350px",position:"relative",border:"1px solid black"}}>
        <style>
        {`

        .nested-link-preview #${nested.linkParent.id} #${nested.node.id} {
            border: 5px solid red !important;
            position:relative;
        }

        //   .nested-link-preview #${nested.linkParent.id} #${nested.node.id}::after {
        //    position:absolute;
        //    z-index:10;
        //     content:"";
        //     display:block;
        //     width:100%;
        //     height:100%;
        //     background:rgba(255,0,0,0.5);

        // }

        `
        }

        </style>

        <div style={{
                    pointerEvents: "none", position: "absolute", left: "-50%", top: "-50%", width: "200%", height: "200%", transform: "scale(0.5)",

                }}>
                    <RenderNodeRecursive screenSize={ScreenSize.Desktop} siteData={siteData} node={nested.linkParent} userContext={siteData.userContext} />
                </div>
       </div>


}

export function RenderLinkNestingList({nested,siteData}:{nested:NestedLinkNode[],siteData:SiteData}){

   return <div className="flex-column gap-large">
        {nested.map((link)=>{
            return <RenderLinkNesting nested={link as NestedLinkNode} siteData={siteData}/>
        })}
    </div>

}

export function FindMissingLinks(data: any, inpages: PageData[]) {

    let pendingList = [data.root];
    let returnList = [];
    if (data?.data?.data) {
        let pages = data.data.data as PageData[];


        for (let i = 0; i < pages.length; i++) {
            try {
                let root = JSON.parse(pages[i].content ?? "") as LayoutNode;

                pendingList.push(root);
                while (pendingList.length > 0) {
                    let node = pendingList.pop();
                    if (!node)
                        continue;
                    for (let c = 0; c < node.children.length; c++) {
                        pendingList.push(node.children[c]);
                    }

                    if (isNodeMissingLink(node)) {
                        let page = inpages.find(x => x.pageId == pages[i].pageId)?.name ?? "unknown";
                        let comp = GetWBComponentByTypename(node.typename);
                        let content = node.content ?? "";
                        let tempDOm = document.createElement("div");
                        tempDOm.innerHTML = content;
                        let text = tempDOm.innerText||tempDOm.textContent;
                        returnList.push(`${comp.displayName} '${text}' missing link on page '` + page + "'");

                    }


                }

            }
            catch (e) {
                console.log("error", e);
            }

        }

    }

    return returnList;
}



function isNodeMissingLink(node: LayoutNode) {

    if (node.typename == wBComponentTypeNames.button ) {
        let link = node.componentAttributes["link"] ?? "";
        return !GetLinkValidation(link, 0).valid;
    }

}

export function GetAllNestedLinksInContainer(container:LayoutNode){
    let pendingNodes = [...container.children];
    let results = [];
    do{
        let node = pendingNodes.pop();

        if(node){
            if(node.children.length>0){
                pendingNodes.push(...node.children);
            }
            if( ( node.componentAttributes['isLink']==="true" || node.componentAttributes['link'].length>4)){
                results.push({node:node,linkParent:container});
            }
        }
    }
    while(pendingNodes.length>0);

    return results;
}